import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';

import { SectionContextType } from '../context';
import { sectionSettingsConstants } from '..';

import { useSectionSettings } from './use-section-settings';

export function useCreateOrUpdateSection() {
  const qc = useQueryClient();
  const {
    methods: { setCreateOrUpdate }
  } = useSectionSettings();
  const [{ page = 1, search }] = useQueryParams({
    page: NumberParam,
    search: StringParam
  });

  return useMutation(
    async (payload: Omit<SectionContextType['createOrUpdate'], 'visible'>) => {
      const { data } = await $api.post('/v1/department', payload);

      return data;
    },
    {
      onError: baseErrorHandler,
      onSuccess: async data => {
        await qc.invalidateQueries([sectionSettingsConstants.queryKeys.DEPARTMENTS, page, search]);

        showMessage(data?.message, data?.accept);

        setCreateOrUpdate({
          visible: false
        });
      }
    }
  );
}
